export const fileDraggerStyle = ((_, { palette = {} }) => ({
  fileDragWrapper: {
    width: '100%',
    height: '190px',
    overflow: 'hidden',
  },

  fileDraggerRoot: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    border: '1px dashed #BBB',
    borderRadius: '12px',
    flexWrap: 'nowrap',
  },

  largeFileDraggerRoot: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '32px',
    border: '1px dashed #BBB',
    borderRadius: '12px',
    textAlign: 'center',
  },

  fileUploadButton: {
    flexGrow: 0,
    flexShrink: 0,
    paddingTop: 34,
    paddingRight: 14,
  },

  largeFileUploadButton: {
    flexGrow: 0,
    flexShrink: 0,
    paddingTop: 5,
  },

  fileDefaultWrapper: {
    flexGrow: 1,
    flexShrink: 1,
  },

  largeFileDefaultWrapper: {
    flexShrink: 1,
  },

  fileUploadIcon: {
    width: '28px',
    height: '28px',
    margin: 'auto',
  },

  icon: {
    fontSize: '28px',
    color: palette.neutralTertiary,
  },

  fileUploadText: {
    marginTop: '8px',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#484644',
  },

  fileUploadTip: {
    marginTop: '8px',
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    lineHeight: '14px',
    color: palette.neutralSecondary,
  },

  fileSelectedWrapper: {
    width: '100%',
    height: '100%',
    background: 'rgba(239, 246, 252, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #005A9E',
    borderRadius: '12px',
  },

  fileSelectedIcon: {
    width: '36px',
    height: '36px',
    pointerEvents: 'none',
    color: palette.blue,
  },

  fileSelectedText: {
    marginTop: '8px',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#484644',
    pointerEvents: 'none',
  },
}));
